import React, { useState, useEffect, useCallback } from "react";
import "../../css/InicioPage/Productos.css"
import axios from "axios";
import { Box, Grid, CircularProgress, Container } from "@mui/material";
import { useInView } from "react-intersection-observer";
import { motion } from "framer-motion";
import { useNavigate } from 'react-router-dom';

export const ServicioInicio = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const backendURL = process.env.REACT_APP_BACKEND_URL;
  const [producto, setProductos] = useState([]);
    const { ref, inView } = useInView({
      triggerOnce: true,
      threshold: 0.2,
    });

  

     const handleClickCategoria = (idCategoria) => {
  navigate(`/producto?id=${idCategoria}`);
};
 

  const fetchSliders = useCallback(async () => {
     setLoading(true)
      try {
        const response = await axios.get(`${backendURL}/api/all/public/producto/home`);
          setProductos(response.data.data);
        setLoading(false)
      } catch (error) {
        console.error("Error al obtener sliders:", error);
      }
    }, [backendURL]);
  
    // Llamada inicial a sliders cuando hay token
    useEffect(() => {
      
        fetchSliders();
      
    }, [fetchSliders]);


  if (loading) {
    return (
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
        <Box display="flex" flexDirection="column" alignItems="center">
          <CircularProgress size={80} thickness={6} /> 
        </Box>
      </div>
    );
  }

  return (
    <Container maxWidth="lg" sx={{ marginTop: '50px', marginBottom: '50px' }}>
      <Box sx={{ py: 6, px: 2 }}>
        <div className="TituloPorductosHome">
          <h1 className="parte1" >Nuestros </h1>

          <h1 className="parte2"> Productos</h1>
        </div>
        <Grid container spacing={4} justifyContent="center" ref={ref}>
          {producto.map((service, index) => (
            <Grid size={{ xs: 12, sm: 6, md:4, lg:3 }}  key={index} sx={{display:'flex', alignItems:'center', justifyContent:'center', flexDirection:'column'}}>
             <motion.div
                             initial={{ opacity: 0, y: 30 }}
                             animate={inView ? { opacity: 1, y: 0 } : {}}
                             transition={{ duration: 0.6, delay: index * 0.2 }}
                             
                           >
              <Box className="cardservicioproducto"  onClick={() => handleClickCategoria(service.id)} >
                <Box  className="ImagenProductoHome">
                  {service.icono && (
                    <img
                      src={`${backendURL}/${service.icono}`}
                       alt="HOD | Maquinas Dispensadoras"
                                        title="HOD | Maquinas Dispensadoras"
                    />
                  )}
                </Box>

                <Box sx={StyleCardBox}>
                  <Box sx={TextStileBox}>
                    <h2 className="TituloPorductoHomeSelecion">{service.titulo}</h2>
                   {service.titulo1 && (
                      <h2 className="TituloPorductoHomeSelecion">{service.titulo1}</h2>
                    )}
                  </Box>
                   <Box
                    sx={{
                      height: '3px', // grosor de la línea
                      width: '100px',
                      backgroundColor: service.color,
                      my: 1, // margen vertical (arriba y abajo)
                      borderRadius: '4px'
                    }}
                  />
                  <Box sx={{
                    display:'flex',
                    alignItems:'center',
                    justifyContent:'center',
                    flexDirection:'column',
                    marginTop:'10px'
                  }} >
                    <h3 className="DescripcionProdutoHomeSelecion">{service.descripcion}</h3>
                     <h3 className="DescripcionProdutoHomeSelecion">{service.descripcion1}</h3>
                      <h3 className="DescripcionProdutoHomeSelecion">{service.descripcion2}</h3>
                       <h3 className="DescripcionProdutoHomeSelecion">{service.descripcion3}</h3>
                  </Box>
                </Box>
              </Box></motion.div>
            </Grid>
          ))}
         
        </Grid>
      </Box>
    </Container>
  );
};


/* estilo */



const StyleCardBox = {

  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  flexDirection: 'column',
  textTransform: 'uppercase'
}

const TextStileBox ={
  height:'80px',
  marginTop:'20px',
  display:'flex',
  alignItems:'center',
  textAlign:'center',
  flexDirection:'column',

}